import React from "react";
import rollbarService from "../../service";

class RollbarErrorBoundary extends React.Component {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error: any, errorInfo: any) {
        // rollbarService.error(error)
        // rollbarService.info(errorInfo)
    }

    render() {
        return this.props.children;
    }
}

export default RollbarErrorBoundary